import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import ContentList from "./ContentList"

const Content = () => {
	return (
		<Container>
			<Paper elevation={2} sx={{padding: 2, margin: 1}}>
				<Stack spacing={2} direction="column" width="100%" alignItems="center">
					<Typography variant="h5" fontWeight={800}>Todos Artigos</Typography>
					<ContentList />
					<Button variant="contained" component={Link} to={-1} sx={{ width: 200 }}>Voltar</Button>					
				</Stack>
			</Paper>
		</Container>
	)
}

export default Content;